import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { computeDashboardDest } from "@/lib/computeDashboardDest";
import { postAuthHandoff } from "@/lib/postAuthHandoff";
import { getSupabase } from "@/lib/supabaseClient";

export default function DashboardRedirect() {
  const navigate = useNavigate();
  const [q] = useSearchParams();
  const { ready, user } = useAuth();

  useEffect(() => {
    if (!ready) return;

    // not signed in → go to login, preserve any next
    if (!user) {
      navigate("/coming-soon", { replace: true });
      return;
    }

    // Check if this is an OAuth redirect with role information
    const src = q.get("src");
    const role = q.get("role");
    
    console.log('🔧 [DashboardRedirect] URL params:', { src, role, allParams: Object.fromEntries(q.entries()) });
    
    if (src === "oauth" && role) {
      console.log('🔧 [DashboardRedirect] OAuth redirect detected with role:', role);
      console.log('🔧 [DashboardRedirect] SessionStorage login_intent_role:', sessionStorage.getItem("login_intent_role"));
      
      // Use postAuthHandoff for OAuth flows to ensure proper profile creation
      (async () => {
        try {
          await postAuthHandoff(role as "employer" | "job_seeker");
        } catch (error) {
          console.error('🔧 [DashboardRedirect] OAuth handoff failed:', error);
          // Fallback to regular dashboard computation
          const supabase = getSupabase();
          const dest = await computeDashboardDest({ supabase });
          sessionStorage.removeItem("oauth_started");
          sessionStorage.removeItem("login_intent_role");
          navigate(dest, { replace: true });
        }
      })();
      return;
    }

    // Regular flow - compute where to go; **never** throw, fast timeout inside helper
    (async () => {
      const supabase = getSupabase();
      const dest = await computeDashboardDest({ supabase });
      // clean one-shot oauth flags
      sessionStorage.removeItem("oauth_started");
      sessionStorage.removeItem("login_intent_role");
      navigate(dest, { replace: true });
    })();
  }, [ready, user, navigate, q]);

  return <div className="p-8 text-center text-sm text-slate-500">Redirecting…</div>;
}
